module.exports = "/images/ico-classic-blue.png?6e5ac6dcd98a3ec1deb12ddb456b73a1";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/ico-classic-blue.png
// module id = +PSf
// module chunks = 1